import type { Chat } from '@/types/chat';

export class ChatStorage {
  private CHATS = 'chat-history';
  private CURRENT = 'currentChatId';

  private get ls(): Storage | null {
    return typeof window !== 'undefined' ? window.localStorage : null;
  }

  setChats(chats: Chat[]): void {
    try {
      this.ls?.setItem(this.CHATS, JSON.stringify(chats));
    } catch {}
  }

  setCurrentChatId(id: string): void {
    try {
      this.ls?.setItem(this.CURRENT, id);
    } catch {}
  }
}
